/** @format */

/**
 * External dependencies
 */
import { merge } from 'lodash';

/**
 * Internal dependencies
 */
import { ERROR } from '../constants';
import { serializeQueryArgs } from '../utils';

const DEFAULT_STATE = {
};

export default function productReducer( state = DEFAULT_STATE, action ) {
	const queryKey = serializeQueryArgs( action.query );

	switch ( action.type ) {
		case 'SET_PRODUCTS':
			return merge( {}, state, {
				[ queryKey ]: {
					records: action.products,
					count: action.count,
				},
			} );
		case 'SET_PRODUCTS_ERROR':
			return merge( {}, state, {
				[ queryKey ]: ERROR,
			} );
	}

	return state;
}

